import { render, staticRenderFns } from "./ModalGroupTypeCategoryEdit.vue?vue&type=template&id=2d21aae4&scoped=true"
import script from "./ModalGroupTypeCategoryEdit.vue?vue&type=script&lang=js"
export * from "./ModalGroupTypeCategoryEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalGroupTypeCategoryEdit.vue?vue&type=style&index=0&id=2d21aae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d21aae4",
  null
  
)

export default component.exports